import { useEffect, useRef, useState } from 'react'
import { FibonacciCurve } from './components/FibonacciCurve.tsx'
import { ThemeToggle } from './components/ThemeToggle.tsx'

export function App() {
  const [progress, setProgress] = useState(0)
  const progressRef = useRef(0)

  useEffect(() => {
    function onWheel(e: WheelEvent) {
      e.preventDefault()
      const delta = e.deltaY / 5000
      progressRef.current = Math.max(0, Math.min(1, progressRef.current + delta))
      setProgress(progressRef.current)
    }

    let touchStartY = 0
    function onTouchStart(e: TouchEvent) {
      touchStartY = e.touches[0].clientY
    }
    function onTouchMove(e: TouchEvent) {
      e.preventDefault()
      const dy = touchStartY - e.touches[0].clientY
      touchStartY = e.touches[0].clientY
      const delta = dy / 2000
      progressRef.current = Math.max(0, Math.min(1, progressRef.current + delta))
      setProgress(progressRef.current)
    }

    window.addEventListener('wheel', onWheel, { passive: false })
    window.addEventListener('touchstart', onTouchStart, { passive: true })
    window.addEventListener('touchmove', onTouchMove, { passive: false })
    return () => {
      window.removeEventListener('wheel', onWheel)
      window.removeEventListener('touchstart', onTouchStart)
      window.removeEventListener('touchmove', onTouchMove)
    }
  }, [])

  return (
    <div className="h-dvh w-full overflow-hidden" style={{ backgroundColor: 'var(--color-canvas)' }}>
      <div className="absolute top-4 right-4 z-10">
        <ThemeToggle />
      </div>
      <div className="h-full grid grid-cols-1 landscape:grid-cols-[3fr_2fr] md:grid-cols-[3fr_2fr] grid-rows-[auto_1fr] landscape:grid-rows-[1fr] md:grid-rows-[1fr]">
        <div className="flex flex-col items-center landscape:items-start md:items-start justify-center gap-4 px-8 landscape:pl-8 landscape:pr-16 md:pl-8 md:pr-16 order-1 landscape:order-2 md:order-2 pt-8 pb-4 landscape:py-0 md:py-0">
          <h1 className="text-4xl md:text-5xl font-bold">Welcome</h1>
          <p className="text-lg md:text-xl text-(--color-muted)">I'm Sergio Cardenas Espinoza</p>
          <p className="mt-2 text-sm text-(--color-muted) opacity-70 leading-relaxed max-w-sm text-center landscape:text-left md:text-left">
            Chilean. Passionate about how technology improves our society.
            Amateur practitioner of endurance sports and, most importantly,
            constant missionary of enjoying the path that God has given to me and my family.
          </p>
        </div>
        <div className="relative flex items-center justify-center order-2 landscape:order-1 md:order-1 overflow-hidden">
          <div className="w-[90vmin] h-[90vmin] landscape:w-[80vmin] landscape:h-[80vmin] md:w-[95vmin] md:h-[95vmin]">
            <FibonacciCurve progress={progress} />
          </div>
          <div className="absolute bottom-[10%] left-1/2 -translate-x-1/2 text-center max-w-md">
            <p className="text-sm text-(--color-text) opacity-50 font-medium tracking-wide">
              Fibonacci Spiral
            </p>
            <p className="mt-1 text-xs tracking-widest text-(--color-text) opacity-40 font-light">
              Fₙ = Fₙ₋₁ + Fₙ₋₂ &nbsp; 1, 1, 2, 3, 5, 8, 13, 21, 34, 55...
            </p>
            <p className="mt-2 text-[10px] text-(--color-muted) opacity-30 leading-relaxed">
              Each number is the sum of the two before it.
              The spiral grows by the golden ratio every quarter turn.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
